import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, Input, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ChatEmoteListComponent } from '../chat-emote-list/chat-emote-list.component';
import { ChatService } from '../chat.service';
import { IconComponent } from '@shared/icon/icon.component';
import { SessionService } from '@shared/session.service';

@Component({
  selector: 'app-chat-bottom',
  templateUrl: './chat-bottom.component.html',
  styleUrls: ['./chat-bottom.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ChatEmoteListComponent, FormsModule, IconComponent],
})
export class ChatBottomComponent {
  @ViewChild('chatInput') chatInput: ElementRef;
  @Input() message = '';
  toggleEmoteList = false;

  constructor(private chatService: ChatService, private cd: ChangeDetectorRef, public session: SessionService) {}

  sendMessage($event: any): void {
    if ($event && $event.key !== 'Enter') {
      return;
    }
    this.chatService.sendMessage(this.message);
    this.message = '';
  }

  onEmoteSelected(event: any) {
    const emote = event;
    if (!this.message) {
      this.message = '';
    }

    this.message += `:${emote}: `;
    this.toggleEmoteList = false;
    this.cd.detectChanges();

    setTimeout(() => {
      this.chatInput.nativeElement.selectionStart = this.message.length;
      this.chatInput.nativeElement.selectionEnd = this.message.length;
      this.chatInput.nativeElement.focus();
    }, 0);
  }
}
